// extracted by mini-css-extract-plugin
export default {"reportSectionHeading":"R9LKrqDNKXHjlSAUC62X","roundIcon":"VX_SOnLMn2YU_IwNMtnX"};